import { Col, Row } from "reactstrap";
import ModalComponent from "../Modal/modal"
import { useState } from "react";
import { CustomButton } from "../../../widgets";
import { useNavigate } from "react-router-dom";

const NoUserCreditsModal = () => {
    const [showModal, setShowModal] = useState(true);

    const navigate = useNavigate();
  return (
    <ModalComponent
          width={window.innerWidth > 700 ? window.innerWidth / 2 : window.innerWidth}
          isOpen={showModal}
          onClose={() => {setShowModal(false)}}
          header={"No Credits Available"}
          centered={true}
          customClass="no-credits-available-modal"
          body={
            <>
                <Row>
                  NO CREDITS AVAILABLE. PLEASE UPGRADE YOUR PLAN.
                </Row>
                <Row>
                  <CustomButton type="primary" text="Upgrade Plan" onClick={() => {navigate('/ai-module')}} />
                </Row>
            </>
          }
          footer={<></>}
        />
  )
}

export default NoUserCreditsModal